import app from '../../app'
import { translate as $t } from './i18n'
import {ucFirst} from "./Support/TextHelper";

const globals = app.config.globalProperties;

globals.$placeholder = (subject, key = null) => {
    return $t('place_holder', {
        subject: $t(subject).toLowerCase(),
        type: key ? $t(key).toLowerCase() : ''
    });
};

globals.$fieldTitle = (subject, title = null, titleCapitalize = false, infix = null) => {
    if (title) {
        let translation = $t('field_title', {
            subject: $t(subject),
            infix: infix ? $t(infix).toLowerCase() : '',
            title: titleCapitalize ? $t(title) : $t(title).toLowerCase()
        })
        return translation.split(' ').filter(a => a).join(' ');
    }
    return $t(subject);
};

globals.$totalLabel = (name) => {
    return $t('total_context', {name: $t(name).toLowerCase()})
}
globals.$rateLabel = (name) => {
    return $t('status_wise_rate', {status: $t(name)})
}
globals.$allLabel = (name) => {
    return $t('all_feature_name', {name: $t(name)})
}
globals.$addLabel = (name) => {
    return $t('add_feature_name', {name: $t(name)})
}
globals.$editLabel = (name) => {
    return $t('edit_feature_name', {name: $t(name)})
}
globals.$copyLabel = (name) => {
    return $t('copy_feature_name', {name: $t(name)})
}
globals.$fieldLabel = (subject, key = 'name') => {
    return $t('field_label', {
        subject: $t(subject),
        key: key ? $t(key).toLowerCase() : '',
    })
}
globals.$textAreaPlaceHolder = (name) => {
    return $t('textarea_placeholder', {
        name: $t(name).toLowerCase()
    })
}
